export enum EmailProviderEnum {
  CLIENT = 1,
  DEVELOP = 2,
}
